<div class="player-time-control-container">
  <div class="player-time-control__not-live">
    <span #currentTime class="player-time-control__current-time"></span>
    <span class="player-time-control__separator"> / </span>
    <span #totalTime class="player-time-control__total-time"></span>
  </div>
</div>
